import { apiClient } from './api';

// ─── Karty podarunkowe ──────────────────────────────────────────────────────
export type GiftCardStatus = 'ACTIVE' | 'USED' | 'EXPIRED' | 'CANCELLED';

export interface GiftCardTx {
  id: string;
  amount: string | number;
  type: 'PURCHASE' | 'REDEEM' | 'ADJUST' | 'CANCEL';
  note?: string | null;
  createdAt: string;
}

export interface GiftCard {
  id: string;
  code: string;
  initialValue: string | number;
  balance: string | number;
  status: GiftCardStatus;
  note?: string | null;
  expiresAt?: string | null;
  createdAt: string;
  client?: { id: string; firstName: string; lastName: string } | null;
  transactions: GiftCardTx[];
}

export const giftCardApi = {
  list: (params: { salonId: string; status?: string; search?: string }) =>
    apiClient.get<GiftCard[]>('/gift-cards', { params }).then((r) => r.data),
  create: (body: Record<string, unknown>) => apiClient.post<GiftCard>('/gift-cards', body).then((r) => r.data),
  redeem: (id: string, amount: number, note?: string) =>
    apiClient.post<GiftCard>(`/gift-cards/${id}/redeem`, { amount, ...(note ? { note } : {}) }).then((r) => r.data),
  adjust: (id: string, amount: number, note: string) =>
    apiClient.post<GiftCard>(`/gift-cards/${id}/adjust`, { amount, note }).then((r) => r.data),
  cancel: (id: string, note?: string) =>
    apiClient.post<GiftCard>(`/gift-cards/${id}/cancel`, { note }).then((r) => r.data),
};

// ─── Pakiety usług ──────────────────────────────────────────────────────────
export interface PackageItem {
  id: string;
  quantity: number;
  serviceId: string;
  service: { id: string; name: string; price?: string | number };
}

export interface ServicePackage {
  id: string;
  name: string;
  description?: string | null;
  price: string | number;
  originalPrice?: string | number | null;
  validityDays?: number | null;
  isActive: boolean;
  items: PackageItem[];
  _count?: { sold: number };
}

export interface ClientPackageUsage {
  id: string;
  serviceId: string;
  usedAt: string;
  note?: string | null;
}

export interface ClientPackage {
  id: string;
  status: 'ACTIVE' | 'USED' | 'EXPIRED' | 'CANCELLED';
  pricePaid: string | number;
  purchasedAt: string;
  expiresAt?: string | null;
  package: ServicePackage;
  client: { id: string; firstName: string; lastName: string };
  usages: ClientPackageUsage[];
}

export const packageApi = {
  list: (salonId: string, includeInactive = true) =>
    apiClient.get<ServicePackage[]>('/packages', { params: { salonId, includeInactive } }).then((r) => r.data),
  create: (body: Record<string, unknown>) => apiClient.post<ServicePackage>('/packages', body).then((r) => r.data),
  update: (id: string, body: Record<string, unknown>) =>
    apiClient.patch<ServicePackage>(`/packages/${id}`, body).then((r) => r.data),
  sell: (id: string, body: { clientId: string; pricePaid?: number; note?: string }) =>
    apiClient.post<ClientPackage>(`/packages/${id}/sell`, body).then((r) => r.data),
  listSold: (params: { salonId: string; clientId?: string; status?: string }) =>
    apiClient.get<ClientPackage[]>('/packages/sold', { params }).then((r) => r.data),
  useSold: (id: string, serviceId: string, note?: string) =>
    apiClient.post<ClientPackage>(`/packages/sold/${id}/use`, { serviceId, ...(note ? { note } : {}) }).then((r) => r.data),
  cancelSold: (id: string, note?: string) =>
    apiClient.post<ClientPackage>(`/packages/sold/${id}/cancel`, { note }).then((r) => r.data),
};
